// Hand-drawn festival laurel marks, modeled on official selection badges (dark-mode friendly)
export function Laurel({ children, testid }) {
    return (
        <span
            data-testid={testid}
            className="inline-flex items-center gap-2 px-2 py-1.5 group"
        >
            <svg width="12" height="26" viewBox="0 0 12 26" fill="none" className="shrink-0 -scale-x-100">
                <path
                    d="M11 1 C4 5 2 13 5 25 M9 6 l-5 -1 M7.5 11 l-5 -0.5 M6.5 16 l-5 0 M6 21 l-4.5 0.5"
                    stroke="currentColor"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                />
            </svg>
            <span className="font-mono-x text-[9px] sm:text-[10px] tracking-[0.2em] text-center leading-[1.6] uppercase transition-colors duration-300 group-hover:text-[#FF3333]">
                {children}
            </span>
            <svg width="12" height="26" viewBox="0 0 12 26" fill="none" className="shrink-0">
                <path
                    d="M11 1 C4 5 2 13 5 25 M9 6 l-5 -1 M7.5 11 l-5 -0.5 M6.5 16 l-5 0 M6 21 l-4.5 0.5"
                    stroke="currentColor"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                />
            </svg>
        </span>
    );
}
